import React from "react";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import Button from "react-bootstrap/Button";

export default class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            trackingNumberOrHawb: '',
        }
    }

    render() {
        return (
            <Form inline onSubmit={this.handleSubmit} >
                <FormControl
                    type="text"
                    placeholder="Track or HAWB"
                    className="mr-sm-2"
                    onChange={this.handleChange}
                    value={this.state.trackingNumberOrHawb}
                    style={{width:"350px"}}
                />
                <Button variant="outline-success" type="submit">Search</Button>
            </Form>
        );
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.history.push('/packages/' + this.state.trackingNumberOrHawb.toUpperCase());
    };

    handleChange = (e) => {
        this.setState({trackingNumberOrHawb: e.target.value})
    };

}